/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { selectCurrentUserApiToken, selectCurrentUserId } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import AlertModal from "./AlertModal";
import submitCtisid from "../functions/submitCtisidAPI";
import { Button, Segment } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { changeTool } from "../slices/footer/footerSlice";

// eslint-disable-next-line no-empty-pattern
const CtisConvertPage = ({ }) => {
    const [searchParams] = useSearchParams();
    const urlCTISid = searchParams.get("ctisid");
    const dispatch = useDispatch();
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);

    let ctisIdFill = "";
    if (window.location.hash?.length === 12) {
        ctisIdFill = window.location.hash.substring(1);
    }

    const [CTISEntryState, setCTISEntryState] = useState({
        "ctisid": urlCTISid || ctisIdFill,
        "loadingSubmission": false
    });

    const [alertModalState, setAlertModalState] = useState({
        open: false, alertHistory: [], header: "", content: ""
    });

    const changeCTISEntryState = (newValue, field) => {
        setCTISEntryState(prevState => {
            return {
                ...prevState,
                [field]: newValue
            };
        });
    };

    const submitCtisIdOnPage = async (ctisid, redirect) => {
        changeCTISEntryState(true, "loadingSubmission");
        if (ctisid === undefined) {
            ctisid = CTISEntryState.ctisid.trim();
        }
        if (redirect === undefined) {
            redirect = true;
        }

        if (ctisid) {
            changeCTISEntryState(true, "loadingSubmission");
        } else {
            setAlertModalState(prevState => {
                return {
                    ...prevState,
                    "open": true,
                    "header": "Please enter a EU CTIS ID.",
                    "content": ""
                };
            });
        }

        let response = await submitCtisid(ctisid, apiToken);

        if (response?.success) {
            if (redirect) {
                if (response.jobAlreadyRunning && response.message) {
                    setAlertModalState(prevState => {
                        return {
                            ...prevState,
                            "open": true,
                            "header": "Job Currently In Process",
                            "content": response.message
                        };
                    });
                } else if (response.numberOfResourcesCreated) {
                    if (response.largeCollection) {
                        const messageContent = "The EU CTIS record was converted to " + response.numberOfResourcesCreated + " FHIR Resources. Click out to view the ResearchStudy Resource. Because the number of Resources created is so large, it may take a few minutes before the referenced Resources are loaded to the FEvIR Platform.";
                        setAlertModalState(prevState => {
                            return {
                                ...prevState,
                                "open": true,
                                "header": "Processing",
                                "content": messageContent
                            };
                        });
                    } else {
                        const messageContent = "The EU CTIS record was converted to " + response.numberOfResourcesCreated + " FHIR Resources. Click out to view the ResearchStudy Resource.";
                        setAlertModalState(prevState => {
                            return {
                                ...prevState,
                                "open": true,
                                "header": "Complete",
                                "content": messageContent
                            };
                        });
                    }
                } else if (response.message) {
                    setAlertModalState(prevState => {
                        return {
                            ...prevState,
                            "open": true,
                            "header": "",
                            "content": response.message
                        };
                    });
                }
                if (response.researchstudyfoi) {
                    navigate(`/resources/ResearchStudy/${response.researchstudyfoi}`);
                }
            }
        } else if (response?.errormessage) {
            changeCTISEntryState(false, "loadingSubmission");
            setAlertModalState(prevState => {
                return {
                    ...prevState,
                    "open": true,
                    "header": "Error",
                    "content": response.errormessage
                };
            });
        } else {
            changeCTISEntryState(false, "loadingSubmission");
            //console.log(response)
            const messageContent = "We were unable to convert this item. Perhaps this EU CTIS ID: " + ctisid + " doesn't exist or there are issues in its structure.";
            setAlertModalState(prevState => {
                return {
                    ...prevState,
                    "open": true,
                    "header": "Error",
                    "content": messageContent
                };
            });
        }

    };

    const handleKeyUp = (event) => {
        if (event.key === 'Enter' && !alertModalState.open) {
            submitCtisIdOnPage();
        }
    }

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR EU CTIS-to-FEvIR Converter"));
        dispatch(changeTool("Computable Publishing®: EU CTIS-to-FEvIR Converter"));
    }, []);

    useEffect(() => {
        if ((urlCTISid || ctisIdFill) && apiToken) {
            submitCtisIdOnPage(urlCTISid || ctisIdFill);
        }
    }, [apiToken]);

    return (
        <div>
            <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <br />
                {isLoggedIn ?
                    <>
                        <TextField style={{ width: "180px" }} className="inputField" type='text'
                            size="small" variant='outlined'
                            placeholder='EU CTIS ID' value={CTISEntryState.ctisid}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => { changeCTISEntryState(e.target.value, "ctisid"); }}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{display: 'inline-block', marginTop: "5px"}}>
                            <Button className="formButton positive"
                                content="Submit"
                                compact
                                onClick={() => submitCtisIdOnPage()}
                                disabled={CTISEntryState.loadingSubmission || !CTISEntryState.ctisid?.trim()}
                            />
                        </span>
                        <br />
                        <br />
                        {CTISEntryState.loadingSubmission &&
                            <img className={CTISEntryState.loadingSubmission ? 'visible' : 'invisible'}
                                style={{ height: "22px" }} src="/spinner.gif" alt="Loading" />
                        }
                        <div style={{ "textAlign": "left", "width": "100%" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <h3>{CTISEntryState.loadingSubmission ?
                                <>Your requested EU CTIS study record is being converted to</>
                                :
                                <><br />Enter a EU CTIS Identifier to automatically create</>
                            } HL7<sup>&#174;</sup> FHIR<sup>&#174;</sup> Resources.</h3>
                            <br />
                            <p>The EU CTIS-to-FEvIR Converter is currently in development and only converts a portion of the EU CTIS Record at this time.</p>
                            <br />
                            <span>HL7<sup>&#174;</sup> and FHIR<sup>&#174;</sup> are the registered trademarks of Health Level Seven International and their use of these trademarks does not constitute an endorsement by HL7.</span>
                        </div>
                    </>
                    :
                    <h3>Please login to use the EU CTIS-to-FEvIR Converter.</h3>
                }
            </Segment>
        </div>
    );
};

export default CtisConvertPage;